module.exports = __webpack_public_path__ + "3964270f9d1ee01607173a1f938d9dc4.woff";